import { Menu, Transition } from '@headlessui/react';
import Link from 'next/link';
import { Fragment } from 'react';
import Image from 'next/image';
import Button from '@/components/common/Button';
import { AccountSection, SECTIONS } from '@/components/layout/AccountLayout';
import { useRouter } from 'next/router';

export default function AccountDropdown(): React.ReactElement {
  const { pathname } = useRouter()
  return (
    <div className="lg:hidden text-center z-10 mt-5">
      <Menu
        as="div"
        className="relative inline-block text-left w-full mb-7"
      >
        {({ open }) => (
          <>
            <div>
              <Menu.Button
                className={`inline-flex w-full border border-pearl justify-between items-center bg-onyx bg-opacity-20 px-4 py-2 text-[14px] font-normal text-pearl hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 h-[44px]`}
              >
                {SECTIONS.filter((section) => pathname.includes(section.path))[0]?.title || 'Dashboard'}
                <Image src="/icons/arrow-down-white.svg" alt='arrow-down' width={15} height={15} />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
              show={open}
            >
              <Menu.Items
                static
                className="absolute right-0 w-full origin-top-right border border-onyx border-t-0 bg-white shadow-lg ring-opacity-5 hover:font-bold focus:outline-none"
              >
                <div className="px-1 py-1 flex flex-col">
                  <Menu.Item as="button">
                    <Link href="/account" passHref>
                      <Button
                        className={`text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm hover:font-semibold`}
                        value="dashboard"
                      >
                        Dashboard
                      </Button>
                    </Link>
                  </Menu.Item>
                  {SECTIONS.map((section: AccountSection, i) => (
                    <Menu.Item as="button" key={i}>
                      <Link href={`/account/${section.path}`} passHref>
                        <Button
                          className={`text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm hover:font-semibold`}
                          value={section.path}
                        >
                          {section.title}
                        </Button>
                      </Link>
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  );
}
